import { ListItem, Typography } from "@mui/material";
import { Link } from "react-router-dom";

import HNSColors from "../../../ui library/HNSColors";

export default function EntityLocationsListItem({ data }) {
  const classes = "self-center px-0 py-2 text-center text-sm";

  return (
    <ListItem className="border-b border-gray-200 px-0 hover:bg-gray-50">
      <div className="flex w-full items-center">
        <div className="w-[30%] self-center px-0 py-2 text-left text-sm">
          <Link to={`/provider/${data.id}/location-info/hours-of-operation`}>
            <Typography
              className="break-words whitespace-normal text-sm"
              sx={{ color: HNSColors.primary[500], fontWeight: 500 }}
            >
              {data.name}
            </Typography>
          </Link>
        </div>
        <div className={`${classes} w-[25%]`}>{data.locationId}</div>
        <div className={`${classes} w-[45%]`}>{data.address}</div>
      </div>
    </ListItem>
  );
}
